import {
  addProvidersToWorkspace as requestAddProvidersToWorkspace,
  createWorkspace as requestCreateWorkspace,
  deleteProvidersFromWorkspace as requestRemoveProvidersFromWorkspace,
  deleteWorkspace as requestDeleteWorkspace,
  getWorkspaces,
  replaceUsersInWorkspace as requestReplaceUsersInWorkspace
} from "@utils/aegean_api_handler";

import { EVENT_TYPE } from "@utils/helpers";
import { notify } from "@utils/notifications";

export const GET_WORKSPACES_REQUEST = "GET_WORKSPACES_REQUEST";
export const GET_WORKSPACES_SUCCESS = "GET_WORKSPACES_SUCCESS";
export const GET_WORKSPACES_ERROR = "GET_WORKSPACES_ERROR";
export const GET_WORKSPACE_DATA_REQUEST = "GET_WORKSPACE_DATA_REQUEST";
export const GET_WORKSPACE_DATA_SUCCESS = "GET_WORKSPACE_DATA_SUCCESS";
export const GET_WORKSPACE_DATA_ERROR = "GET_WORKSPACE_DATA_ERROR";
export const ADD_USERS_TO_WORKSPACE_REQUEST = "ADD_USERS_TO_WORKSPACE_REQUEST";
export const ADD_USERS_TO_WORKSPACE_SUCCESS = "ADD_USERS_TO_WORKSPACE_SUCCESS";
export const ADD_USERS_TO_WORKSPACE_ERROR = "ADD_USERS_TO_WORKSPACE_ERROR";
export const ADD_PROVIDERS_TO_WORKSPACE_REQUEST = "ADD_PROVIDERS_TO_WORKSPACE_REQUEST";
export const ADD_PROVIDERS_TO_WORKSPACE_SUCCESS = "ADD_PROVIDERS_TO_WORKSPACE_SUCCESS";
export const ADD_PROVIDERS_TO_WORKSPACE_ERROR = "ADD_PROVIDERS_TO_WORKSPACE_ERROR";
export const REMOVE_PROVIDERS_FROM_WORKSPACE_REQUEST = "REMOVE_PROVIDERS_FROM_WORKSPACE_REQUEST";
export const REMOVE_PROVIDERS_FROM_WORKSPACE_SUCCESS = "REMOVE_PROVIDERS_FROM_WORKSPACE_SUCCESS";
export const REMOVE_PROVIDERS_FROM_WORKSPACE_ERROR = "REMOVE_PROVIDERS_FROM_WORKSPACE_ERROR";
export const CREATE_WORKSPACE_REQUEST = "CREATE_WORKSPACE_REQUEST";
export const CREATE_WORKSPACE_SUCCESS = "CREATE_WORKSPACE_SUCCESS";
export const CREATE_WORKSPACE_ERROR = "CREATE_WORKSPACE_ERROR";
export const DELETE_WORKSPACE_REQUEST = "DELETE_WORKSPACE_REQUEST";
export const DELETE_WORKSPACE_SUCCESS = "DELETE_WORKSPACE_SUCCESS";
export const DELETE_WORKSPACE_ERROR = "DELETE_WORKSPACE_ERROR";

export const fetchWorkspaces = () => (dispatch, getState) => {
  const store = getState();

  if (store.workspaces.isFetching || store.workspaces.data) {
    // Request for (somewhat) static data - no need for multiple requests
    return Promise.resolve();
  }

  dispatch({ type: GET_WORKSPACES_REQUEST });

  return getWorkspaces()
    .then((workspaces) => {
      dispatch({
        type: GET_WORKSPACES_SUCCESS,
        workspaces
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_WORKSPACES_ERROR,
        error
      });
    });
};

export const replaceUsersInWorkspace = (workspace_id, user_ids) => (dispatch) => {
  dispatch({
    type: ADD_USERS_TO_WORKSPACE_REQUEST,
    workspace_id
  });

  return requestReplaceUsersInWorkspace(workspace_id, { user_ids })
    .then((workspace) => {
      dispatch({
        type: ADD_USERS_TO_WORKSPACE_SUCCESS,
        workspace,
        workspace_id
      });
    })
    .catch((error) => {
      dispatch({
        type: ADD_USERS_TO_WORKSPACE_ERROR,
        error
      });
    });
};

export const addProvidersToWorkspace = (workspace_id, provider_version_ids) => (dispatch) => {
  dispatch({
    type: ADD_PROVIDERS_TO_WORKSPACE_REQUEST,
    workspace_id
  });

  return requestAddProvidersToWorkspace(workspace_id, { provider_version_ids })
    .then((workspace) => {
      dispatch({
        type: ADD_PROVIDERS_TO_WORKSPACE_SUCCESS,
        workspace,
        workspace_id
      });
    })
    .catch((error) => {
      dispatch({
        type: ADD_PROVIDERS_TO_WORKSPACE_ERROR,
        error
      });
    });
};

export const removeProvidersFromWorkspace = (workspace_id, provider_version_ids) => (dispatch) => {
  dispatch({
    type: REMOVE_PROVIDERS_FROM_WORKSPACE_REQUEST,
    workspace_id
  });

  return requestRemoveProvidersFromWorkspace(workspace_id, provider_version_ids)
    .then((workspace) => {
      dispatch({
        type: REMOVE_PROVIDERS_FROM_WORKSPACE_SUCCESS,
        workspace,
        workspace_id
      });
    })
    .catch((error) => {
      dispatch({
        type: REMOVE_PROVIDERS_FROM_WORKSPACE_ERROR,
        error
      });
    });
};

export const createWorkspace = (workspaceData, useCaseId) => (dispatch) => {
  dispatch({ type: CREATE_WORKSPACE_REQUEST });

  return requestCreateWorkspace(workspaceData, useCaseId)
    .then((result) => {
      notify("Workspace created.");
      dispatch({
        type: CREATE_WORKSPACE_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: CREATE_WORKSPACE_ERROR,
        error
      });
    });
};

export const deleteWorkspace = workspace_id => (dispatch) => {
  dispatch({ type: DELETE_WORKSPACE_REQUEST });

  return requestDeleteWorkspace(workspace_id)
    .then((result) => {
      notify("Workspace deleted.");
      dispatch({
        type: DELETE_WORKSPACE_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: DELETE_WORKSPACE_ERROR,
        error
      });
    });
};
